<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>

    <v-card>
      <v-card-title>
        Utilização de Veículos
        <v-spacer></v-spacer>
      </v-card-title>
      <div class="actions-section" style="margin: 0">
        <div class="search-bar">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Procurar"
            single-line
            hide-details
          ></v-text-field>
        </div>
        <div class="export-buttons">
          <v-btn
            small
            class="mr-4"
            color="warning"
            style="margin-bottom: 5px"
            @click="generateReport()"
          >
            <span class="pr-1">Exportar PDF</span>
            <v-icon small> insert_drive_file </v-icon>
          </v-btn>
          <download-excel
            class="ml-auto mr-0"
            :data="data"
            :fields="json_fields"
            name="utilização_de_veículos.xls"
          >
            <v-btn small class="mr-4" color="success">
              <span class="pr-1">Exportar XLS</span>
              <v-icon small> insert_drive_file </v-icon>
            </v-btn>
          </download-excel>
        </div>
      </div>
      <br />
      <v-data-table
        no-data-text="Nenhum veículo encontrado"
        no-results-text="Nenhum veículo encontrado"
        :headers="headers"
        :items="data"
        :search="search"
        item-key="plate"
        class="elevation-1"
        :items-per-page="15"
        :footer-props="{
          'items-per-page-text': 'Linhas por página:',
          'items-per-page-options': [15, 30, 50, 100],
        }"
        sort-by="client"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.plate }}</td>
            <td>{{ item.model }}</td>
            <td>{{ item.client }}</td>
            <td>{{ item.completed }}</td>
            <td>{{ item.hours }}</td>
            <td>{{ item.value }}</td>
            <td>
              <ActionButton
                message="Reservas do veículo"
                icon="mdi-open-in-new"
                @onclick="showVehicleDetails(item)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showVehicleRequestsDialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Reservas do Veículo "{{
              vehicleExpanded ? vehicleExpanded.plate : ''
            }}"</span
          >
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="vehicleRequestsHeaders"
            :items="vehicleRequestsData"
            :search="searchVehicleRequests"
            :items-per-page="15"
            :footer-props="{
              'items-per-page-text': 'Linhas por página:',
              'items-per-page-options': [15, 30, 50, 100],
            }"
            no-data-text="Nenhuma reserva encontrada"
            no-results-text="Nenhuma reserva encontrada"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchVehicleRequests"
                label="Procurar"
                class="mx-4"
              ></v-text-field>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showVehicleRequestsDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <vue-html2pdf
      :enable-download="false"
      :preview-modal="true"
      :show-layout="false"
      filename="utilização_de_veículos"
      pdf-format="a3"
      ref="html2Pdf"
      pdf-content-width="600"
      :manual-pagination="true"
    >
      <section slot="pdf-content">
        <VehicleUtilizationReportPDF
          :itemList="data"
          :templatePlans="true"
        ></VehicleUtilizationReportPDF>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import moment from 'moment';
import NumberHelper from '../../helpers/NumberHelper';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleController from '../../controllers/VehicleController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import VueHtml2pdf from 'vue-html2pdf';
import VehicleUtilizationReportPDF from './VehicleUtilizationReportPDF';
import ActionButton from '../shared/ActionButtonsTemplate';

export default {
  components: {
    ActionButton,
    VueHtml2pdf,
    VehicleUtilizationReportPDF,
  },

  data() {
    return {
      vehicleExpanded: null,
      showVehicleRequestsDialog: false,
      data: [],
      vehicleRequestsData: [],
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      searchVehicleRequests: '',
      json_fields: {
        Placa: 'plate',
        Modelo: 'model',
        Cliente: 'client',
        'Reservas Concluídas': 'completed',
        'Horas Totais': 'hours',
        'Valor Total': 'value',
      },
      headers: [
        { text: 'Placa', value: 'plate' },
        { text: 'Modelo', value: 'model' },
        { text: 'Cliente', value: 'client' },
        { text: 'Reservas Concluídas', value: 'completed' },
        { text: 'Horas Totais', value: 'hours' },
        { text: 'Valor Total', value: 'value' },
        { text: '' },
      ],
      vehicleRequestsHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Placa', value: 'plate' },
        { text: 'Usuário', value: 'user' },
        { text: 'Check-In', value: 'checkIn' },
        { text: 'Check-Out', value: 'checkOut' },
        { text: 'Valor', value: 'value' },
      ],
    };
  },

  created() {
    this.vehicleController = new VehicleController(this.$resource);
    this.vehicleRequestController = new VehicleRequestController(
      this.$resource
    );

    this.getVehicles();
  },

  methods: {
    async getVehicles() {
      this.blockScreen = true;

      try {
        const vehicles = await this.vehicleController.getAllVehicles();

        vehicles.forEach(async vehicle => {
          const { id, plate, vehicle_model, client } = vehicle;

          let hours = 0;
          let value = 0;

          const vehicleRequests = await this.vehicleRequestController.getCompletedVehicleRequests(
            vehicle.id
          );

          vehicleRequests.forEach(request => {
            const { end_date, begin_date } = request;

            hours += moment(end_date).diff(begin_date, 'h');

            request.transaction.forEach(response => {
              value += Number.parseInt(response.total_value_charged);
            });
          });

          this.data.push({
            id,
            plate,
            model: vehicle_model.model,
            client: client.name,
            completed: vehicleRequests.length,
            hours,
            value: `R$ ${NumberHelper.formatPrice(value)}`,
          });
        });
      } catch (error) {
        this.$awn.alert('Falha ao obter veículos');

        console.error(error);
      } finally {
        this.blockScreen = false;
      }
    },

    async getRequests(vehicle_id) {
      this.blockScreen = true;

      try {
        this.vehicleRequestsData = [];

        const requests = await this.vehicleRequestController.getCompletedVehicleRequests(
          vehicle_id
        );

        requests.forEach(request => {
          const { user, vehicle } = request;

          let value = 0;
          request.transaction.forEach(response => {
            value += Number.parseInt(response.total_value_charged);
          });

          this.vehicleRequestsData.push({
            id: request.id,
            value: `R$ ${NumberHelper.formatPrice(value)}`,
            checkIn: moment(request.begin_date).format('DD[/]MM[/]YYYY HH:mm'),
            checkOut: moment(request.end_date).format('DD[/]MM[/]YYYY HH:mm'),
            user: user.name,
            plate: vehicle.plate,
          });
        });
      } catch (error) {
        this.$awn.alert('Falha ao obter as reservas do veículos');

        console.error(error);
      } finally {
        this.blockScreen = false;
      }
    },

    async showVehicleDetails(vehicle) {
      this.vehicleExpanded = vehicle;
      await this.getRequests(vehicle.id);
      this.searchVehicleRequests = '';
      this.showVehicleRequestsDialog = true;
    },

    generateReport() {
      if (this.$refs.html2Pdf) this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style scoped lang="scss">
.actions-section {
  padding: 0 16px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.search-bar {
  display: flex;
  flex: 1;
  margin-right: 16px;
}

.export-buttons {
  button {
    margin-right: 0 !important;
  }
}
</style>
